if($('footer#footer').length){
    $('<section class="spodnicast"><div class="container"><div class="row"></div></div></section>').insertBefore('footer#footer');
    $('.custom-footer .contact-wrap').appendTo('.spodnicast div.row');

    if($(".instagramFeed").length){
        $('footer#footer').before($('footer#footer .customInstagram'))
        $(".instagram-widget>a").each(function(){
            $(".instagramFeed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
        })
    }
}